<script setup>
import {onMounted, ref} from 'vue'
import CustomMenu from "@/components/NewPC/CustomMenu.vue";
import CustomLeftMenu from "@/components/NewPC/CustomLeftMenu.vue";
import LeftLightning from "@/components/NewPC/LeftLightning.vue";
import RightLightning from "@/components/NewPC/RightLightning.vue";
import {getPlayerList} from "@/api/common";
import {formatTimeTwo, getMedia} from "@/utils/utils";
import GiftEntry from "@/components/NewPC/GiftEntry.vue";
import {useTgaStore} from "@/store/tga";
import useAccount from "@/store/account";
const tga = useTgaStore()
const accountStore = useAccount();

const tabs = ref(0);
const playerListOrigin = ref([]);
const showPlayerListOrigin = ref([]);
let timestamp = formatTimeTwo('YMDhm')

const tabIndex = ref(0)

const handleChangeContent = (index) => {
  if (index == tabs.value) return
  tabs.value = index;
}

const getImages = (typeid) => {
  const path = getMedia(timestamp,"/market/res/skin/ui_"+typeid+".png")
  return path;
}

const handleChangeTabIndex = index => {
  if (index == tabIndex.value) return
  tabIndex.value = index;
  if (index == 0) {
    showPlayerListOrigin.value = playerListOrigin.value;
  } else {
    showPlayerListOrigin.value = playerListOrigin.value.filter(f => f.position == index);
  }
}
const handleJumpHome = () => {
  router.push('/')
}
onMounted(() => {

  getPlayerList().then((res) => {
    if (res.data.code == 0) {
      playerListOrigin.value = res.data.data;
      showPlayerListOrigin.value = res.data.data;
    } else {
      playerListOrigin.value = [];
      showPlayerListOrigin.value = [];
    }
  })

  tga.tgaLogin("202504_GUANWANG", accountStore.getterAccount() ? accountStore.getterAccount():'未绑定');
  // 用户存在，上报
  tga.tgaTrack('web_campaigns_event', {
    web_campaigns_op: 'pc_page_exposure',
    account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
    gps1: accountStore.getterAccount() ? accountStore.account.invite_code:null,
    gps2: "游戏资料"
  })
})
</script>

<template>
  <div class="player_center">
    <custom-menu :active="3" />
    <div class="content">
      <img src="@/assets/newPc/topup/topup_logo.png" @click="handleJumpHome" alt="" class="logo_icon">
      <div class="player_block">
        <div class="left_tag">
          <div :class="{'active': tabIndex == 0}" @click="handleChangeTabIndex(0)" data-type="全部">全部</div>
          <div :class="{'active': tabIndex == 5}" @click="handleChangeTabIndex(5)" data-type="中锋">中锋</div>
          <div :class="{'active': tabIndex == 4}" @click="handleChangeTabIndex(4)" data-type="大前">大前</div>
          <div :class="{'active': tabIndex == 3}" @click="handleChangeTabIndex(3)" data-type="小前">小前</div>
          <div :class="{'active': tabIndex == 2}" @click="handleChangeTabIndex(2)" data-type="分卫">分卫</div>
          <div :class="{'active': tabIndex == 1}" @click="handleChangeTabIndex(1)" data-type="控卫">控卫</div>
        </div>
        <div class="right_player">
          <template v-for="item of showPlayerListOrigin">
            <div v-if="item.position == 5" class="player_item_parent">
              <div class="newTag" v-if="item.newTag"></div>
              <div class="player_item" data-type="中锋" >
                <img :src="getImages(item.typeid)" alt="">
                <div class="name">{{item.name}}</div>
                <div class="skill_block"><span>{{item.talent}}</span></div>
              </div>
            </div>
            <div v-else-if="item.position == 4" class="player_item_parent">
              <div class="newTag" v-if="item.newTag"></div>
              <div class="player_item" data-type="大前">
                <div class="newTag" v-if="item.newTag"></div>
                <img :src="getImages(item.typeid)" alt="">
                <div class="name">{{item.name}}</div>
                <div class="skill_block">{{item.talent}}</div>
              </div>
            </div>
            <div v-else-if="item.position == 3" class="player_item_parent">
              <div class="newTag" v-if="item.newTag"></div>
              <div class="player_item" data-type="小前">
                <div class="newTag" v-if="item.newTag"></div>
                <img :src="getImages(item.typeid)" alt="">
                <div class="name">{{item.name}}</div>
                <div class="skill_block">{{item.talent}}</div>
              </div>
            </div>
            <div v-else-if="item.position == 2" class="player_item_parent">
              <div class="newTag" v-if="item.newTag"></div>
              <div class="player_item" data-type="分卫">
                <div class="newTag" v-if="item.newTag"></div>
                <img :src="getImages(item.typeid)" alt="">
                <div class="name">{{item.name}}</div>
                <div class="skill_block">{{item.talent}}</div>
              </div>
            </div>
            <div v-else-if="item.position == 1" class="player_item_parent">
              <div class="newTag" v-if="item.newTag"></div>
              <div class="player_item" data-type="控卫">
                <div class="newTag" v-if="item.newTag"></div>
                <img :src="getImages(item.typeid)" alt="">
                <div class="name">{{item.name}}</div>
                <div class="skill_block">{{item.talent}}</div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <custom-left-menu type="Information" @on-click="handleChangeContent" class="left_menu" />
      <gift-entry class="gift_entry" />
      <left-lightning class="left_lightning" />
      <right-lightning class="right_lightning" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.player_center {
  width: 100vw;
  height: 100vh;
  background: transparent url("@/assets/newPc/page_bg.png") no-repeat center center;
  background-size: cover;


  .content {
    width: 100vw;
    height: 100vh;
    background: transparent url("@/assets/newPc/information_bg.png") no-repeat top center;
    background-size: contain;
    position: relative;
    display: flex;
    justify-content: center;
    padding-top: 13.4375vw;
    box-sizing: border-box;

    .logo_icon {
      position: absolute;
      left: 2.265625vw;
      top: 2.03125vw;
      width: 7.3046875vw;
      height: 4.0234375vw;
    }

    .player_block {
      width: 71.3671875vw;
      height: 30.9375vw;
      background-color: #fff;
      position: relative;
      z-index: 1;

      display: flex;
      flex-direction: row;
      align-items: center;

      .left_tag {
        width: 13.28125vw;
        height: 24.5703125vw;
        flex: none;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;

        &:after {
          position: absolute;
          content: "";
          top: 0;
          bottom: 0;
          right: 0;
          background-color: #B3B3B3;
          width: 2px;
        }

        div {
          background-color: #B3B3B3;
          color: #fff;
          font-size: 1.09375vw;
          width: 7.421875vw;
          height: 2.0703125vw;
          line-height: 2.0703125vw;
          padding-left: 0.625vw;
          margin-bottom: 1.9921875vw;
          cursor: pointer;
          &.active {
            width: 9.3359375vw;
            height: 2.046332vw;
            line-height: 2.046332vw;
            padding-left: 1.5625vw;

            &[data-type="全部"] {
              background-color: #FFEC13;
            }
            &[data-type="中锋"] {
              background-color: #E93838;
            }
            &[data-type="大前"] {
              background-color: #7545AF;
            }
            &[data-type="小前"] {
              background-color: #26C1E2;
            }
            &[data-type="分卫"] {
              background-color: #FFAE22;
            }
            &[data-type="控卫"] {
              background-color: #58D033;
            }
          }
        }
      }

      .right_player {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        height: 24.5703125vw;
        overflow-y: auto;
        padding-left: 3.515625vw;
        padding-top: 0.390625vw;


        .player_item {
          width: 8.9453125vw;
          height: 11.6796875vw;
          margin-right: 1.5625vw;
          margin-bottom: 1.171875vw;
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          padding: 0.15625vw;
          box-sizing: border-box;
          overflow: hidden;
          .name {
            height: 1.71875vw;
            line-height: 1.71875vw;
            text-align: center;
            font-family: 'SourceHanSansCN-Bold';
            font-size: 1.0546875vw;
            color: #fff;
            position: absolute;
            bottom: 0vw;
            left: 0vw;
            right: 0vw;
            z-index: 1;
          }

          img {
            width: 8.59375vw;
            height: auto;
          }

          .skill_block {
            width: 8.671875vw;
            height: 5.4296875vw;
            background: linear-gradient(to top , rgba(0,0,0,0.5), rgba(255,255,255,0));
            position: absolute;
            bottom: 0.1171875vw;
            left: 0.1vw;
            right: 0.1vw;
            padding-bottom: 1.81875vw;
            box-sizing: border-box;

            font-size: 0.6640625vw;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            color: white;

            text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
          }

          &[data-type="中锋"] {
            background: transparent url("@/assets/newPc/player_bg_2.png") no-repeat center center;
            background-size: contain;
            .name {
              background-color: #E93838;
            }
          }
          &[data-type="大前"] {
            background: transparent url("@/assets/newPc/player_bg_1.png") no-repeat center center;
            background-size: contain;
            .name {
              background-color: #7545AF;
            }
          }
          &[data-type="小前"] {
            background: transparent url("@/assets/newPc/player_bg_3.png") no-repeat center center;
            background-size: contain;
            .name {
              background-color: #26C1E2;
            }
          }
          &[data-type="分卫"] {
            background: transparent url("@/assets/newPc/player_bg_4.png") no-repeat center center;
            background-size: contain;
            .name {
              background-color: #FFAE22;
            }
          }
          &[data-type="控卫"] {
            background: transparent url("@/assets/newPc/player_bg_5.png") no-repeat center center;
            background-size: contain;
            .name {
              background-color: #58D033;
            }
          }

          &:nth-child(5n) {
            margin-right: 0;
          }
        }

        .player_item_parent {
          position: relative;
          .newTag {
            position: absolute;
            top: -0.15625vw;
            right: 0.234375vw;
            z-index: 1;
            &::before {
              position: absolute;
              top: 0;
              right: 0;
              content: "";
              display: block;
              width: 4.0234375vw;
              height: 1.1328125vw;
              background: transparent url("@/assets/newPc/player/new_tag_icon.png") no-repeat center center;
              background-size: contain;
            }

            &::after {
              position: absolute;
              top: 0.234375vw;
              right: 1.5921875vw;
              content: "";
              display: block;
              width: 1.484375vw;
              height: 0.625vw;
              background: transparent url("@/assets/newPc/player/new_icon.png") no-repeat center center;
              background-size: contain;
            }
          }
        }
      }
    }

    .left_menu {
      position: absolute;
      top: 16.09375vw;
      left: 3.0078125vw;
      z-index: 1;
    }

    .gift_entry {
      position: absolute;
      top: 29.5703125vw;
      right: 1.640625vw;
      z-index: 1;
      width: 9.0625vw;
      height: 6.171875vw;
    }

    .left_lightning {
      position: absolute;
      left: 0;
      top: 28.59375vw;
    }

    .right_lightning {
      position: absolute;
      right: 0;
      top: 8.671875vw;
    }
  }


}
</style>